<template>
  <v-container>
  </v-container>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>

</style>
